import { passwordRules as passwordRulesDefault } from './password-rules.brand.default';
import { passwordRules as paswwordRulesNaf } from '../validation-rules/password-rules.brand.gmfs';
import { PasswordValidationRule } from '../password-validation';
import config from 'sitecore.config';

/**
 * Gets password validation rules based on brand
 * @param brand - The brand to get rules for
 * @returns Array of password validation rules for the specified brand
 */
function getPasswordRules(): PasswordValidationRule[] {
  const siteName = config.defaultSite;
  if (siteName === 'GMFS') {
    return paswwordRulesNaf;
  }
  return passwordRulesDefault;
}

export const passwordRules: PasswordValidationRule[] = getPasswordRules();
